// Stable per-browser session id. Reused across telemetry surfaces
// (taglines, feedback) so server-side correlations work.
const SESSION_ID_KEY = "hl:session_id:v1";

export function getSessionId(): string {
  if (typeof window === "undefined") return "";
  try {
    let id = window.localStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      window.localStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch {
    return "";
  }
}
